// prod
export const config = {
    url: {
        URL             : 'https://www.secure-direct-hotel-booking.com/customer/',
        API_URL         : 'https://www.secure-direct-hotel-booking.com/customer/ajax',
        BASENAME        : '/customer',
        BOOKING_ENGINE  : 'https://www.secure-direct-hotel-booking.com/module_booking_engine/index.php',
        BANK_FORM_URL   : 'https://www.secure-direct-hotel-booking.com/module_booking_engine/payonline_hotel/form_module_bancaire.php',
        URL_MB          : 'https://www.misterbooking.com',
        LOGO_MB         : 'https://www.misterbooking.com/sources/logo_mb/misterbooking.com.jpg',
    },
    Gmap : {
        KEY : 'AIzaSyBJE3yoEOG1bpJPMHqHhLIdtJonPRwKAUg',
    }
};